export const text = {
  title: 'Notifications',
};
